jQuery(function ($) {
    jQuery('.checkout-button').on('click', function (e) {
        //get button url
        var url = jQuery(this).attr('href');
        if (jQuery('#customer_notes_text').val() !== '') {
            e.preventDefault();
            //send ajax request to save the note
            var data = {
                'action': 'amavida_maybe_save_order_note',
                'note': jQuery('#customer_notes_text').val(),
                'nonce': amavida.nonce
            };
            jQuery.post(amavida.ajaxurl, data, function (response) {
                if (response.success) {
                    //redirect to the checkout page
                    window.location.href = url;
                }
            });
        }

    });

    if (jQuery('.woocommerce-billing-fields .wc_avatax_validate_address').length && jQuery('#ship-to-different-address').length) {
        //move it after .woocommerce-shipping-fields
        jQuery('.woocommerce-billing-fields .wc_avatax_validate_address').remove();
        jQuery('.woocommerce-shipping-fields').after(jQuery('.woocommerce-shipping-fields .wc_avatax_validate_address'));

    }

    $(document).on('change', 'form.woocommerce-checkout #ship-to-different-address-checkbox', function () {
        $('.woocommerce-error, .woocommerce-message, .wc-avatax-address-validation-result').remove();
        if ($(this).is(':checked')) {
            jQuery('.wc_avatax_validate_address').data('address-type', 'shipping');
        } else {
            jQuery('.wc_avatax_validate_address').data('address-type', 'billing');
        }

    })



    if (jQuery('.woocommerce-Addresses a.add').length) {
        jQuery('.woocommerce-Addresses a.add').addClass('button')
    }

    //check if there are any a tags without href on all pages
    jQuery('a:not([href])').each(function () {
        //put a # href in
        jQuery(this).attr('href', '#');
    });

    jQuery('.trigger-quick-add').on('click', function (e) {
        e.preventDefault();
        jQuery(this).hide();
        var parent = jQuery(this).closest('.quick-add-wrapper');
        //add visible css to parent
        jQuery(parent).css('visibility', 'visible').css('opacity', '1');
        jQuery('.variations_form, .close', parent).show();
    });

    jQuery('.close').on('click', function (e) {
        e.preventDefault();

        var parent = jQuery(this).closest('.quick-add-wrapper');
        //delete visible css to parent
        jQuery(parent).removeAttr('style');

        jQuery('.variations_form, .close', parent).hide();
        jQuery('.trigger-quick-add', parent).show();

    })

    var order_guide = {

        init: function () {
            if (jQuery('.variations_form').length) {
                var $form = jQuery('.variations_form');
                $form.on('hide_variation', order_guide.maybe_disable_button);
                $form.on('show_variation', order_guide.maybe_enable_button);

            }
            if (jQuery('.add_to_order_guide').length) {
                if (jQuery('.wc-variation-selection-needed').length) {
                    console.log(jQuery('.single_add_to_cart_button.wc-variation-selection-needed'))
                }

                jQuery('.shopping-lists .close').on('click', order_guide.close);


                jQuery('.add_to_order_guide').on('click', order_guide.add_to_order_guide);
                jQuery('.add_to_shopping_list').on('click', order_guide.add_to_shopping_list);
                jQuery('.create_new_shopping_list').on('click', order_guide.show_create_new_shopping_list);
            }

        },
        maybe_disable_button: function () {
            jQuery('.add_to_order_guide').addClass('disabled');
            jQuery('.shopping-lists').hide();
        },
        maybe_enable_button: function () {
            jQuery('.add_to_order_guide').removeClass('disabled');
        },
        close: function (e) {
            e.preventDefault();
            jQuery('.shopping-lists').hide();
        },
        show_create_new_shopping_list: function (e) {
            e.preventDefault();
            jQuery('.shopping-lists ul').hide();
            jQuery('.shopping-lists').append('<form class="create-new-shopping-list" data-list_id=0><input type="text" name="new_list_name" placeholder="Enter a title for the new order guide" /><button type="submit">Create</button><button class="cancel_new_shopping_list">Cancel</button></form>').get(0).scrollIntoView();
            jQuery('.create-new-shopping-list').on('submit', order_guide.add_to_shopping_list);
            jQuery('.cancel_new_shopping_list').on('click', order_guide.cancel_new_shopping_list);

        },
        cancel_new_shopping_list: function (e) {
            e.preventDefault();
            jQuery('.create-new-shopping-list').remove();
            jQuery('.shopping-lists ul').show();
        },
        add_to_order_guide: function (e) {
            e.preventDefault();
            jQuery('.shopping-lists').show();
            //open .shopping-lists in a modal


        },
        add_to_shopping_list: function (e) {
            e.preventDefault();
            var list_id = jQuery(this).data('list_id');

            if (jQuery('form.cart').length) {
                var $form = jQuery('form.cart');

                var data = {
                    'action': 'amavida_add_to_shopping_list',
                    'product_id': jQuery('[name="add-to-cart"]', $form).val(),
                    'list_id': list_id,
                    'nonce': amavida.nonce
                };

            }
            if (jQuery('.variations_form').length) {
                var $form = jQuery('.variations_form');

                var data = {
                    'action': 'amavida_add_to_shopping_list',
                    'product_id': jQuery('[name="add-to-cart"]', $form).val(),
                    'variation_id': jQuery('[name="variation_id"]', $form).val(),
                    'list_id': list_id,
                    'nonce': amavida.nonce
                };
            }

            jQuery('.shopping-lists').block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } })

            if (jQuery('.create-new-shopping-list').length) {
                data.new_list_name = jQuery('[name="new_list_name"]').val();
                if (data.new_list_name === '') {
                    jQuery('.shopping-lists').unblock();
                    alert('Please enter a title for the new order guide');
                    return;
                }
            }

            jQuery.post(amavida.ajaxurl, data, function (response) {

                if (response.success) {
                    jQuery('.woocommerce-message').remove()
                    jQuery('.woocommerce-notices-wrapper').append(response.data.notice);

                    jQuery('.shopping-lists').unblock();
                    //scroll to top of page
                    jQuery('html, body').animate({ scrollTop: 0 }, 'slow');
                } else {
                    jQuery('.shopping-lists').unblock();
                    alert(response.data.error_message);
                }
            });
        }
    }

    order_guide.init();

    var quick_add = {
        init: function () {
            if (jQuery('.quick-add-wrapper').length) {
                jQuery('.quick-add-wrapper form.cart').on('submit', quick_add.add_to_cart);
                jQuery('.quick-add-wrapper a.amavida-add-to-cart').on('click', quick_add.add_to_cart_simple);

            }

        },
        maybe_hide_notices: function () {

        },
        add_to_cart: function (e) {
            e.preventDefault();
            var $form = jQuery(this);
            //get parent element of this
            var parent = jQuery(this).closest('.quick-add-wrapper');
            var data = {
                'action': 'amavida_add_to_cart',
                'product_id': jQuery('[name="add-to-cart"]', $form).val(),
                'quantity': jQuery('[name="quantity"]', $form).val(),
                'nonce': amavida.nonce
            };

            if (jQuery('[name="variation_id"]', $form).length) {
                data.product_id = jQuery('[name="variation_id"]', $form).val();
                item = {};

                $form.find('select[name^=attribute]').each(function () {

                    var attribute = $(this).attr("name");
                    var attributevalue = $(this).val();

                    item[attribute] = attributevalue;
                });

                data.variation = item;
            }

            var $subscriptionInput = $form.find('input[name^="convert_to_sub_"]:checked');
            if ($subscriptionInput.length) {
                data.subscription_key = $subscriptionInput.val();
                data.subscription_key_name = $subscriptionInput.attr('name');
            } else {
                var $subscriptionSelect = $form.find('select[name^="convert_to_sub_dropdown"]');
                if ($subscriptionSelect.length && $subscriptionSelect.val()) {
                    var dropdownName = $subscriptionSelect.attr('name') || '';
                    var idMatch = dropdownName.match(/(\d+)$/);
                    if (idMatch) {
                        data.subscription_key_name = 'convert_to_sub_' + idMatch[1];
                        data.subscription_key = $subscriptionSelect.val();
                    }
                }
            }

            jQuery(parent).block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } })

            jQuery.post(amavida.ajaxurl, data, function (response) {

                jQuery(parent).unblock();
                if (response.success) {

                    //set form selects to default
                    $form.find('select').each(function () {
                        jQuery(this).val(jQuery('option:first', this).val());
                    });
                    jQuery('.single_variation', parent).hide();
                    jQuery('.single_variation_wrap', parent).before(response.data.notice)

                    //and disappear after 2 seconds
                    setTimeout(function () {
                        jQuery('.woocommerce-message', parent).fadeOut(1000);
                    }, 2000);


                } else {
                    alert(response.data.error_message);
                }
            });
        },
        add_to_cart_simple: function (e) {
            e.preventDefault();
            var _this = this;
            var parent = jQuery(this).closest('.quick-add-wrapper');
            var data = {
                'action': 'amavida_add_to_cart',
                'product_id': jQuery(this).data('product_id'),
                'quantity': 1,
                'nonce': amavida.nonce
            };
            jQuery(parent).block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } })

            jQuery.post(amavida.ajaxurl, data, function (response) {

                jQuery(parent).unblock();
                if (response.success) {
                    jQuery(_this).before(response.data.notice)

                    //and disappear after 2 seconds
                    setTimeout(function () {
                        jQuery('.woocommerce-message', parent).fadeOut(1000).remove();
                    }, 2000);

                } else {
                    alert(response.data.error_message);
                }
            });
        }
    }

    quick_add.init();

    var amavida_checkout = {
        init: function () {

            jQuery(document.body).on('updated_checkout', amavida_checkout.remove_coupon_colspan);
            jQuery(document.body).on('removed_coupon_in_checkout', amavida_checkout.move_coupon_notice)

        },
        close_login: function () {
            $('.woocommerce-checkout form.login').slideUp();
            $('body').removeClass('wc-login-shown');
        },
        remove_coupon_colspan: function (e) {
            if (jQuery('.cart-discount th').length) {


                jQuery('.cart-discount th').replaceWith('<td>' + jQuery('.cart-discount th').html() + '</td>');

            }

        },
        move_coupon_notice: function (e) {

            var message = jQuery('.woocommerce-message');
            if (message.length) {
                jQuery('.woocommerce-notices-wrapper').first().after(message);
            }



        }

    }

    amavida_checkout.init();

    var amavida_mobile_mentu = {
        init: function () {
            if ($('.ast-mobile-popup-content').length) {
                jQuery('.ast-mobile-popup-content .ast-header-account a').after(amavida.mobile_toggle);
                jQuery('.ast-mobile-popup-content .ast-header-account .ast-menu-toggle').on('click', amavida_mobile_mentu.toggle_account_menu);

                // Expand Shop/Coffee menu when mobile menu opens
                amavida_mobile_mentu.expand_shop_menu();
            }
        },
        toggle_account_menu: function (e) {
            e.preventDefault();
            console.log('  toggle_account_menu');
            jQuery(this).toggleClass('toggled');
            jQuery('#ast-mobile-popup-wrapper .widget-area').toggleClass('toggled');
        },
        expand_shop_menu: function () {
            var self = this;
            var hasExpanded = false; // Flag to prevent multiple expansions

            // Function to expand Shop/Coffee menu
            function expandMenus() {
                if (hasExpanded) {
                    return; // Already expanded
                }

                // Try multiple selectors to find the mobile menu container
                var menuContainer = jQuery('#ast-hf-mobile-menu, .ast-mobile-popup-inner, .ast-mobile-popup-content').first();

                if (menuContainer.length === 0) {
                    return; // Menu not found yet
                }

                // Find the Shop menu item by text content
                var shopMenuItem = menuContainer.find('.menu-item').filter(function () {
                    var menuLink = jQuery(this).find('> .menu-link, > a').first();
                    var menuText = menuLink.text().trim();
                    return menuText.toLowerCase() === 'shop';
                });

                if (shopMenuItem.length > 0 && shopMenuItem.hasClass('menu-item-has-children')) {
                    // Expand the Shop menu item - add class and set display
                    shopMenuItem.addClass('ast-submenu-expanded');
                    var shopSubmenu = shopMenuItem.find('> .sub-menu, > .children').first();
                    if (shopSubmenu.length > 0) {
                        shopSubmenu.css('display', 'block');
                    }

                    // Also expand the Coffee submenu if it exists
                    var coffeeSubmenu = shopMenuItem.find('.sub-menu .menu-item, .children .menu-item').filter(function () {
                        var menuLink = jQuery(this).find('> .menu-link, > a').first();
                        var menuText = menuLink.text().trim();
                        return menuText.toLowerCase() === 'coffee';
                    });

                    if (coffeeSubmenu.length > 0 && coffeeSubmenu.hasClass('menu-item-has-children')) {
                        coffeeSubmenu.addClass('ast-submenu-expanded');
                        var coffeeSubmenuList = coffeeSubmenu.find('> .sub-menu, > .children').first();
                        if (coffeeSubmenuList.length > 0) {
                            coffeeSubmenuList.css('display', 'block');
                        }
                    }

                    hasExpanded = true;
                }
            }

            // Watch for mobile menu opening
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        var body = mutation.target;
                        if (body.classList.contains('ast-popup-nav-open')) {
                            // Reset flag when menu opens
                            hasExpanded = false;
                            // Try immediately and with delays to catch menu rendering
                            expandMenus();
                            setTimeout(expandMenus, 50);
                            setTimeout(expandMenus, 150);
                            setTimeout(expandMenus, 300);
                        } else {
                            // Reset flag when menu closes
                            hasExpanded = false;
                        }
                    }
                });
            });

            // Also watch for popup becoming active
            var popupObserver = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        var popup = mutation.target;
                        if (popup.classList.contains('active') && popup.classList.contains('show')) {
                            hasExpanded = false;
                            expandMenus();
                            setTimeout(expandMenus, 50);
                            setTimeout(expandMenus, 150);
                            setTimeout(expandMenus, 300);
                        } else {
                            hasExpanded = false;
                        }
                    }
                });
            });

            // Observe body class changes
            if (document.body) {
                observer.observe(document.body, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            }

            // Observe popup element
            var popupElement = document.getElementById('ast-mobile-popup');
            if (popupElement) {
                popupObserver.observe(popupElement, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            }
        }
    }

    amavida_mobile_mentu.init();

    if (jQuery('button.show-password-input').length > 0) {
        jQuery('button.show-password-input').each(function () {
            var $button = jQuery(this);
            var $span = jQuery('<span>', {
                'class': $button.attr('class'),
                'aria-label': $button.attr('aria-label'),
                'aria-describedBy': $button.attr('aria-describedBy')
            });
            $button.replaceWith($span);
        });

        $('.show-password-input').on('click', function (event) {
            event.preventDefault();

            if ($(this).hasClass('display-password')) {
                $(this).removeClass('display-password');
                $(this).attr(
                    'aria-label',
                    woocommerce_params.i18n_password_show
                );
            } else {
                $(this).addClass('display-password');
                $(this).attr(
                    'aria-label',
                    woocommerce_params.i18n_password_hide
                );
            }
            if ($(this).hasClass('display-password')) {
                $(this)
                    .siblings(['input[type="password"]'])
                    .prop('type', 'text');
            } else {
                $(this)
                    .siblings('input[type="text"]')
                    .prop('type', 'password');
            }

            $(this).siblings('input').focus();
        });
    }

})
